import { createAsyncThunk } from "@reduxjs/toolkit"
import { getRequest, getRequestPerEnv } from "./utils/GetRequest"
import { userObject } from "../model/user-object/UserObject.model";
import { RootState } from "../root-redux/RootState";
import { Workflow, WorkflowSummary } from "../model/workflows/Workflow.model";
import { MergeRule } from "../model/merge-rules/MergeRule.model";

export const getAllUserObjects = createAsyncThunk<userObject[], WorkflowSummary[] | Workflow[], { state: RootState }>('workflows/getuserobjects', async (workflows: WorkflowSummary[] | Workflow[], { getState }) => {
    const env = getState().env.selectedEnvItem;

    // Getting all the object ids from the modified by column from workflow summaries
    const objectIds: string[] = [];
    const requests = []
    let result: userObject[] = [];

    workflows.map((item) => {
      if (item.modifiedBy !== null && objectIds.includes(item.modifiedBy) === false)
         {
             objectIds.push(item.modifiedBy)
         }
    });
    //skipping the call in case objectid is empty
    if(objectIds.length === 0)
      return result;
    
    const x = Math.floor(objectIds.length / 15) + 1;
    var objectIdsString = "";
    for (var i = 0; i < x; i++) {
        if((i + 1) * 15 < objectIds.length)
        {
          objectIdsString = objectIds.slice(i * 15, (i + 1) * 15).join(",");
        }
        else
        {
          objectIdsString = objectIds.slice(i * 15, objectIds.length).join(",");
        }
        if ((objectIdsString || "").length > 0) {
            var domain = env === 'dev' || env === 'uat' ? 'predictions' : 'audit';
            requests.push(getRequestPerEnv<userObject[]>(`${domain}/userobjects?objectIds=${objectIdsString}`,env));
        }
    }

    const responses = await Promise.all(requests);

    responses?.forEach((res: any) => {
      result.push(...res.data)
    })

    return result
})